<template>
  <b-sidebar
      :visible="isAddNewCompanySidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      backdrop
      no-header
      right
      @hidden="resetForm"
      @change="val => $emit('update:is-add-new-company-sidebar-active', val)"
  >

    <template #default="{ hide }">

      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center px-2 py-1">
        <h5 class="mb-0">Add New Company</h5>

        <feather-icon icon="XIcon" class="cursor-pointer" @click="hide" />
      </div>

      <!-- Form -->
        <b-form class="p-2" @submit.prevent="onSubmit">

          <!-- Company Name -->
          <b-form-group label="Company Name">
            <b-form-input v-model="companyData.name" />
          </b-form-group>

          <!-- Pricing -->
          <b-form-group label="Pricing">
            <v-select
                v-model="companyData.pricing_id"
                :options="pricingOptions"
                label="name"
                :reduce="opt => opt.id"
            />
          </b-form-group>

          <!-- Category Pricing -->
          <b-form-group label="Category Pricing">
            <v-select
                v-model="companyData.category_pricing"
                :options="categoryOptions"
                label="label"
                :reduce="opt => opt.value"
            />
          </b-form-group>

          <!-- Actions -->
          <div class="d-flex mt-2">
            <b-button variant="primary" type="submit">
              Create
            </b-button>

            <b-button variant="outline-secondary" class="ml-1">
              Cancel
            </b-button>
          </div>

        </b-form>

    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput,
  BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import { ref } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },

  props: {
    isAddNewCompanySidebarActive: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    const loading = ref(false)

    const companyData = ref({
      name: '',
      pricing_id: null,
      category_pricing: '',
    })

    const pricingOptions = ref([
      { id: 1, name: 'Basic Plan' },
      { id: 2, name: 'Premium Plan' },
    ])

    const categoryOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Premium', value: 'premium' },
    ]

    const onSubmit = () => {
      console.log(companyData.value)
    }

    return {
      companyData,
      pricingOptions,
      categoryOptions,
      onSubmit,
      loading,
    }
  }
}
</script>